var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resource-delivery" },
    [
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "130px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "月份" } },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "month",
                                placeholder: "请选择月份",
                                format: "yyyy-MM",
                                "value-format": "yyyy-MM",
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchForm.Month,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "Month", $$v)
                                },
                                expression: "searchForm.Month"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "订单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入订单号" },
                              model: {
                                value: _vm.searchForm.orderNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "orderNo", $$v)
                                },
                                expression: "searchForm.orderNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工单号" },
                              model: {
                                value: _vm.searchForm.ticketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "ticketId", $$v)
                                },
                                expression: "searchForm.ticketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "一级机房" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入一级机房" },
                              model: {
                                value: _vm.searchForm.idcpName,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "idcpName", $$v)
                                },
                                expression: "searchForm.idcpName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("服务器账单列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      "header-style": {
                        "white-space": "normal",
                        "word-break": "break-all",
                        height: "auto",
                        "line-height": "1.2",
                        padding: "8px 0"
                      },
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "num"
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.num || 0))
                                  ])
                                : column.prop === "realNum"
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.realNum || 0))
                                  ])
                                : column.prop === "billType"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.billType === "1" ||
                                          scope.row.billType === 1
                                            ? "success"
                                            : scope.row.billType === "2" ||
                                              scope.row.billType === 2
                                            ? "warning"
                                            : scope.row.billType === "0" ||
                                              scope.row.billType === 0
                                            ? "info"
                                            : "danger",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.billType === "1" ||
                                              scope.row.billType === 1
                                              ? "全额计费"
                                              : scope.row.billType === "2" ||
                                                scope.row.billType === 2
                                              ? "打折计费"
                                              : scope.row.billType === "0" ||
                                                scope.row.billType === 0
                                              ? "不计费"
                                              : "-"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "status"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.status === "已完成"
                                            ? "success"
                                            : scope.row.status === "进行中"
                                            ? "warning"
                                            : "info",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.status || "-") +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "endTime" ||
                                  column.prop === "startTime" ||
                                  column.prop === "olaTime"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row[column.prop]
                                          ? _vm
                                              .$moment(scope.row[column.prop])
                                              .format("YYYY-MM-DD HH:mm:ss")
                                          : "-"
                                      )
                                    )
                                  ])
                                : column.prop === "opTicketid"
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            scope.row.feedback_status ===
                                            "已收单"
                                              ? "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid +
                                                "&isHistory=1"
                                              : "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid +
                                                "&isHistory=1",
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.opTicketid))]
                                    )
                                  ])
                                : column.prop === "isActive"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.isActive === 1 ||
                                          scope.row.isActive === "1"
                                          ? "是"
                                          : scope.row.isActive === 0 ||
                                            scope.row.isActive === "0"
                                          ? "否"
                                          : "-"
                                      )
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row[column.prop] || "-")
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "600px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }